module.exports = __webpack_public_path__ + "static/media/image_2.4f95f648.jpg";